import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_CRD_MAIL;

export default {

  put(payload) {
    return baseApi.put(resource, payload);
  },
};
